import { Component, OnInit } from '@angular/core';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { ProductDao } from '@app/dao/product/product.dao';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';

@Component({
    selector: 'corum-versement-form',
    templateUrl: './corum-versement-form.component.html',
    styleUrls: ['./corum-versement-form.component.scss'],
    standalone: false
})
export class CorumVersementFormComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
    private productDao: ProductDao,
  ) {
    super(formConstructor);
  }

  ngOnInit(): void {
    this.subscriptionFacade.initForm(this);
  }

  onSubmit() {
    this.form.markAsDirty();
    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
